import StateObserver from 'src/StateObserver';
import { duration } from 'src/replicant/utils/duration';
import i18n from 'src/lib/i18n/i18n';

export function getTimestampText(time: number) {
  const now = StateObserver.now();
  const durationSinceTime = now - time;
  if (durationSinceTime < duration({ hours: 1 })) {
    return i18n('friendsVisit.popup.timestamp.justNow');
  }

  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const timestampDay = new Date(time);
  timestampDay.setHours(0, 0, 0, 0);
  const daysSinceLastLogin =
    (today.getTime() - timestampDay.getTime()) / duration({ days: 1 });
  if (daysSinceLastLogin < 1) {
    return i18n('friendsVisit.popup.timestamp.today');
  }
  if (daysSinceLastLogin < 2) {
    return i18n('friendsVisit.popup.timestamp.yesterday');
  }
  if (daysSinceLastLogin < 7) {
    return i18n('friendsVisit.popup.timestamp.nDaysAgo', {
      days: daysSinceLastLogin,
    });
  }
  return i18n('friendsVisit.popup.timestamp.moreThanAWeekAgo');
}
